/* eslint-disable no-param-reassign */
import type { StandardChartLayerSpec } from '../../../../core/layer';
import type { Spec as LineLayerSpec } from '../../../../layer/preset/line/line';
import * as utils from '../../../../util';
import {
  BaseSpec,
  ILayerTypeSpec,
  createDataTypeValidator,
  createEncodingValidator,
  createLayerProcessor
} from '../baseProcessor';

export type Spec = BaseSpec;

// 扩展ILayerTypeSpec以包含__isEncodingValid属性
interface LineLayerTypeWithFields extends ILayerTypeSpec {
  __isEncodingValid?: boolean;
}

type LineLayerType = StandardChartLayerSpec & LineLayerSpec & LineLayerTypeWithFields;

// 创建折线图数据类型验证器
const validateLineDataTypes = createDataTypeValidator('line', [
  { field: 'x', type: ['string', 'date'] },
  { field: 'y', type: 'number', array: true },
  { field: 'z', type: 'string', required: false }
]);

// 创建折线图编码验证器
const validateLineEncoding = createEncodingValidator([
  { field: 'x' },
  { field: 'y', array: true },
  { field: 'z', required: false }
]);

// 额外的检查函数
const additionalLineChecks = (layer: LineLayerType) => {
  const { encoding } = layer;
  if (encoding.z && Array.isArray(encoding.y) && encoding.y.length > 1) {
    // 潜规则：多Y轴与Z维度不能同时使用，会降级为单Y轴
    utils.logger.warn(
      'warning',
      `Multiple Y axes with Z dimension is not supported. Using only the first Y field: "${encoding.y[0]}"`
    );

    // 不需要设置__isEncodingValid=false，因为这只是一个警告，不影响图表渲染
  }
};

// 创建并导出折线图处理器
export const line = createLayerProcessor<LineLayerType>(
  'line',
  validateLineEncoding,
  validateLineDataTypes,
  additionalLineChecks
);
